import Cookies  from 'universal-cookie';
import { EncryptStorage } from 'encrypt-storage';
import { MD5 } from 'crypto-js';
import CerrarSesion from './del_dto';


    const cookies  = new Cookies();
    const secretKey = 'mi-secreto-super-seguro';
    const encryptStorage = new EncryptStorage(secretKey, {
        storageType: 'localStorage', // Puedes usar 'sessionStorage' si lo prefieres
    });
  
    
    const setInfo = (resultado)=>{
      try {   
       
        let fechaActual = new Date();
        fechaActual.setHours(fechaActual.getHours() + 8);
        fechaActual.setMinutes(fechaActual.getMinutes());
        cookies.set( 'elhid',"1b77400", {path:"/"} );//28800000
        cookies.set('elr_fol',28800000 , {path:"/"} );
        
        cookies.set('eltf',fechaActual.getDay(), {path:"/"} );
        cookies.set('algdId' ,fechaActual.getHours(), {path:"/"} );
        cookies.set('ebid-book' ,fechaActual.getMinutes() , {path:"/"} );

        encryptStorage.setItem('ses', {
          nombre: resultado.usuario.strUserName,
          intUserId:resultado.usuario.intUserId,
          
          blnUserEntityIsEmployee:resultado.usuario.blnUserEntityIsEmployee,
           
          strCompanyBillingIdentifier:resultado.usuario.strCompanyBillingIdentifier,
          strCompanyFiscalIdentifier:resultado.usuario.strCompanyFiscalIdentifier,
   
          menuOptions:JSON.stringify(resultado.usuario.menuOptions),
          
          intUserEntityId: resultado.usuario.intUserEntityId,
          intUserEntityTypeId:resultado.usuario.intUserEntityTypeId,
          strCompanyName:resultado.usuario.strCompanyName,
          blnUserMustChangePassword: resultado.usuario.blnUserMustChangePassword,
          dtoCloseSesion:setDate(),
        }); 
        
        window.location.assign="/home";
      }catch(error){
        console.log("Ocurrio un Error: "+error.Messaje)
      }   
    }
    
    const setDate= () => { 
      try {
        const hora_cierre = new Date(); 
        hora_cierre.setHours(( hora_cierre.getHours() + 8));
        //hora_cierre.setMinutes(( hora_cierre.getMinutes()+1));
        //alert("Hora de cierre: " + hora_cierre)
        return hora_cierre;
      } catch (error) {
        console.log("Ocurrio un Error al asignar la hora de cierre: "+error)
      }
    }
    const getDate= () => { 
      try {
        const usuario = encryptStorage.getItem('ses'); 
        if(getVal(usuario.dtoCloseSesion)){ 
          return usuario.dtoCloseSesion;
        }else{
          return new Date();;
        } 
      } catch (error) {
        console.log("Ocurrio un Error al asignar la hora de cierre: "+error)
      }
    }

    const Valid_Date = () => { 
      try {
        const HA = new Date(); 
       // HA.setHours(9);
        const HR = new Date(getDate())
        /*alert( HA )
        alert( HR )*/
        if( HR >=  HA){ 
          return true;
        }else{
          return false;
        } 
      } catch (error) {
        console.log("Ocurrio un Error al asignar la hora de cierre: "+error)
      }
    }
    /*** const validSesion=()=>{
      try {
        if( getUserID() > 0 ){//&& val_date()){
          //window.location.assign('/inicio');
          return true;
        }else{
          return false;
        } 
      } catch (error) {
       // console.log("Ocurrio un Error: "+error.Messaje)
      }
    } ****/
    const validSesion=()=>{
        try {
          if( getUserID() > 0 && Valid_Date() ){ 
            return true;
          }else{
            CerrarSesion()
            return false;
          } 
        } catch (error) {
          console.log("Ocurrio un Error: "+error)
        }
    }
    const getUserName = () => { 
      try {
        const usuario = encryptStorage.getItem('ses'); 
        if(getVal(usuario.nombre)){
          return usuario.nombre;
        }else{
          return "<>no name<>";
        } 
        
      } catch (error) {
       // console.log("Ocurrio un Error: "+error.Messaje)
      }
    }
    const getUserID = () => {
      try {
        const usuario = encryptStorage.getItem('ses'); 
        if(getVal(usuario.intUserId)){
            return usuario.intUserId;
        }else{
          return -1;
        }
      } catch (error) {
       // console.log("Ocurrio un Error: "+error.Messaje)
      }
    }

    const getUserEntityIsEmployee = () => {
      try {

        const usuario = encryptStorage.getItem('ses'); 
        if(getVal(usuario.blnUserEntityIsEmployee)){
            return usuario.blnUserEntityIsEmployee;
        }else{
          return -1;
        }  
        
      } catch (error) {
       // console.log("Ocurrio un Error: "+error.Messaje)
      }
    }

    const getUserEntityName = () => {
      try {
        const usuario = encryptStorage.getItem('ses'); 
        if(getVal(usuario.strCompanyName)){
            return usuario.strCompanyName;
        }else{
          return -1;
        }  
        
      } catch (error) {
       // console.log("Ocurrio un Error: "+error.Messaje)
      }
    }

    const getUserBillingIdentifier = () => {    
        try {
          const usuario = encryptStorage.getItem('ses'); 
          if(validSesion()){
            return usuario.strCompanyBillingIdentifier;
          }else{
            window.location.assign('/login')
          } 
          
        } catch (error) {
         // console.log("Ocurrio un Error: "+error.Messaje)
        }
    }

    const getintUserEntityId = () => { 
      try {
        const usuario = encryptStorage.getItem('ses'); 
        if(getUserID() > 0 && getUserName().trim().length > 0 ){
          return  usuario.intUserEntityId;
        }
      } catch (error) {
       // console.log("Ocurrio un Error: "+error.Messaje)
      } 
    }

    const getIntUserEntityTypeId = () => {
      try {
        const usuario = encryptStorage.getItem('ses'); 
        if(getUserID() > 0 && getUserName().trim().length > 0 ){
          return usuario.intUserEntityTypeId;
        }
      } catch (error) {
       // console.log("Ocurrio un Error: "+error.Messaje)
      }
       
    }

        /* identificador de facturacion (strCompanyFiscalIdentifier) */
        const getUserFiscalIdentifier = () => { 
          try {
            const usuario = encryptStorage.getItem('ses'); 
            if(validSesion()){ 
              return usuario.strCompanyFiscalIdentifier;
            }else{
              window.location.assign('/login')
            }
          } catch (error) {
           // console.log("Ocurrio un Error: "+error.Messaje)
          }
        }
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////

    const ValidaIsModal=(item)=>{ ///PARA SABER SI EL USUARIO TIENEN ACCESO A UN ELEMENTO DE MENU 
      try {
        const menuOptions = getMenuUser();
        let redir = false;
        if( menuOptions !== undefined){
          for (let index = 0; index < menuOptions.length; index++) {
            if(menuOptions[index].strModuleOptionLanguageId === item){ //"cancelar_vins"){
              if(menuOptions[index].blnIsModal === 1){
                redir=true;
                break;
              }  
            }
          }
        }
        return redir;
      } catch (error) {
       // console.log("Ocurrio un Error: "+error.Messaje)
      }
    }

    const ValidaItemMenu=(item)=>{ ///PARA SABER SI EL USUARIO TIENEN ACCESO A UN ELEMENTO DE MENU
      try {
        const menuOptions = getMenuUser(); 
        let redir = false;
        if( menuOptions !== undefined){
          for (let index = 0; index < menuOptions.length; index++) {
            if(menuOptions[index].strModuleOptionLanguageId === item){  
              redir=true;
              break;
            }
          }
        }
        return redir;
      } catch (error) {
       // console.log("Ocurrio un Error: "+error.Messaje)
      } 
    }
    const getUserParam=(param)=>{
       try {
            const usuario = encryptStorage.getItem('ses'); 
            if(validSesion()){ 
              return usuario[param];

            }else{
              window.location.assign('/login')
            }
          } catch (error) {
           // console.log("Ocurrio un Error: "+error.Messaje)
          }
    }
    const getMenuUser = () => { 
      try {
        const usuario = encryptStorage.getItem('ses'); 
        if(getUserID() > 0 && getUserName().trim().length > 0 ){
          //return JSON.parse(localStorage.getItem('abfENEIKC23g5sF2345E23SADF2fFsiN'));
          /*if(getVal(localStorage.getItem('abfENEIKC23g5sF2345E23SADF2fFsiN'))){
            return JSON.parse(localStorage.getItem('abfENEIKC23g5sF2345E23SADF2fFsiN'));*/
          if(getVal(usuario.menuOptions)){
            return JSON.parse(usuario.menuOptions); 
          }else{
            return {};
          } 

        }
      } catch (error) {
       // console.log("Ocurrio un Error: "+error.Messaje)
      }
    }

    const getVal = (value) => {
      if( value === ""  ||  value === null ||  value  === undefined){
        return false
      }else{
        return true; 
      }
    }
    
    /*const getUserID = () => {
        try {
          if(getVal(localStorage.getItem('iAAafa'))){
            return localStorage.getItem('iAAafa');
          }else{
            return -1;
          }
        } catch (error) {
         // console.log("Ocurrio un Error: "+error.Messaje)
        }
    }
     
    const getUserName = () => { 
      try {
        if(getVal(localStorage.getItem('asA5AaSD'))){
          return localStorage.getItem('asA5AaSD');
        }else{
          return "";
        } 
        
      } catch (error) {
       // console.log("Ocurrio un Error: "+error.Messaje)
      }
    }

    const getUserEntityIsEmployee = () => {
      try {
        return localStorage.getItem('AFeaASDAsaASD'); 
      } catch (error) {
       // console.log("Ocurrio un Error: "+error.Messaje)
      }
    } 

    const getUserBillingIdentifier = () => { 
      try {
        if(validSesion()){
          return localStorage.getItem('aSDrr4aS566A');
        }else{
          window.location.assign('/login')
        } 
      } catch (error) {
       // console.log("Ocurrio un Error: "+error.Messaje)
      }
    }

    const getintUserEntityId = () => { 
      try {
        if(getUserID() > 0 && getUserName().trim().length > 0 ){
          return  localStorage.getItem('3RFW6i4FgGsukB63Ugnb');
        }
      } catch (error) {
       // console.log("Ocurrio un Error: "+error.Messaje)
      }
    }

    const getIntUserEntityTypeId = () => {
      try {
        if(getUserID() > 0 && getUserName().trim().length > 0 ){
          return localStorage.getItem('3FInmAT7FGiiieS7dBVD');
        }
      } catch (error) {
       // console.log("Ocurrio un Error: "+error.Messaje)
      }
       
    }

        //* identificador de facturacion (strCompanyFiscalIdentifier) 
        const getUserFiscalIdentifier = () => { 
          try {
            if(validSesion()){
              return localStorage.getItem('adWWsDweiTR45Sa');
            }else{
              window.location.assign('/login')
            }
          } catch (error) {
           // console.log("Ocurrio un Error: "+error.Messaje)
          }
        }
    */
     

    /* el RFC (strCompanyBillingIdentifier) */
    
    const val_date = () =>{
      let d = new Date();
       //cookies.set('eltf',fechaActual.getDay(), {path:"/"} );
       //cookies.set('algdId' ,fechaActual.getHours(), {path:"/"} );
       //cookies.set('ebid-book' ,fechaActual.getMinutes() , {path:"/"} );

      if( (cookies.get('eltf') !== d.getDay())  || (cookies.get('algdId') >= d.getHours() && cookies.get('ebid-book') <= d.getMinutes() )){
        CerrarSesion();
        return false;
      }else{
        return true;
      }
    }

    export { setInfo, getUserID, validSesion ,getUserName,getMenuUser, ValidaItemMenu, ValidaIsModal,getUserEntityIsEmployee,getUserEntityName,getintUserEntityId,getIntUserEntityTypeId
          ,getUserFiscalIdentifier,getUserBillingIdentifier,getUserParam };